<mat-dialog-content xmlns="http://www.w3.org/1999/html">
  <h2>{{"admin.countries.edit" | translate}} {{"intelligence-reporting.round-of-questions.round-of" | translate}} {{"intelligence-reporting.questions.questions" | translate}}</h2>
  <mat-card-content>
    <form (submit)="sendEditRequest()" [formGroup]="roundOfQuestionsCreateForm" autocomplete="off">
      <div class="form-container">

        <mat-form-field appearance="fill">
          <mat-label>{{"kf-reporting.year" |translate}}</mat-label>
          <mat-select [formControl]="yearControl" [disabled]="true">
            <mat-option *ngFor="let year of years" [value]="year">{{year}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>{{"admin.countries.name" |translate}}</mat-label>
          <input [formControl]="nameControl" matInput type="text">
        </mat-form-field>

        <p *ngIf="questions">{{questionsText}}</p>
        <mat-stepper>
          <mat-step>
            <ng-template matStepLabel>Categories</ng-template>
            <div class="table-container" *ngIf="categories">
              <table class="categories-table" mat-table [dataSource]="categories">

                <ng-container matColumnDef="description">
                  <th mat-header-cell *matHeaderCellDef>{{"admin.dialogs.description" |translate}}</th>
                  <td mat-cell *matCellDef="let category">{{category.description}}</td>
                </ng-container>

                <ng-container matColumnDef="edit">
                  <th mat-header-cell *matHeaderCellDef>Selected?</th>
                  <td mat-cell *matCellDef="let category; index as i">
                    <mat-checkbox [checked]="setCategoryChecked(i)" (change)="categoryCheckedChange($event, i)"></mat-checkbox>
                  </td>
                </ng-container>

                <ng-container matColumnDef="order">
                  <th mat-header-cell *matHeaderCellDef>Order</th>
                  <td mat-cell *matCellDef="let category; index as i">
                    <mat-select [disabled]="!setCategoryChecked(i)" [value]="categorySelectMap.get(category)">
                      <mat-option *ngFor="let option of categorySelectMap | keyvalue; index as index" [value]="index +1" (onSelectionChange)="categorySelectChange($event, category)">{{index + 1}}</mat-option>
                    </mat-select>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsCategories"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsCategories;"></tr>
              </table>
            </div>

            <div class="wizard-buttons-container align-right">
              <button mat-raised-button matStepperPrevious disabled>
                <mat-icon class="material-icons-outlined">chevron_left</mat-icon>
                <span>Back</span>
              </button>
              <button mat-raised-button matStepperNext type="button" color="primary"
                      (click)="questionsStep()" [disabled]="!allCategoriesSelectedWithOrder">
                <span>Next</span>
                <mat-icon class="material-icons-outlined">chevron_right</mat-icon>
              </button>
            </div>
          </mat-step>

          <mat-step>
            <ng-template matStepLabel>Questions</ng-template>
            <div *ngFor="let category of categorySelectMap | keyvalue: valueOrderAsc; index as index">
              <h3>{{category.key.description}}</h3>
              <div class="table-container">
                <table class="questions-table" mat-table [dataSource]="questions[index]">

                  <ng-container matColumnDef="questions.shortCode">
                    <th mat-header-cell *matHeaderCellDef>{{"intelligence-reporting.questions.short-code" |translate}}</th>
                    <td mat-cell *matCellDef="let question">{{question.shortCode}}</td>
                  </ng-container>

                  <ng-container matColumnDef="questions.description">
                    <th mat-header-cell *matHeaderCellDef>{{"admin.dialogs.description" |translate}}</th>
                    <td mat-cell *matCellDef="let question">{{question.description }}</td>
                  </ng-container>

                  <ng-container matColumnDef="questions.questionType">
                    <th mat-header-cell *matHeaderCellDef>{{"intelligence-reporting.questions.registration-level" |translate}}</th>
                    <td mat-cell *matCellDef="let question">{{question.questionType}}</td>
                  </ng-container>

                  <ng-container matColumnDef="edit">
                    <th mat-header-cell *matHeaderCellDef>Selected?</th>
                    <td mat-cell *matCellDef="let question; index as i">
                      <mat-checkbox [checked]="setQuestionChecked(index, i)" (change)="questionsCheckedChange($event, index, i)"></mat-checkbox>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="order">
                    <th mat-header-cell *matHeaderCellDef>Order</th>
                    <td mat-cell *matCellDef="let question; index as i">
                      <mat-select [disabled]="!setQuestionChecked(index, i)" [value]="this.questionsSelectMap[index].get(question)">
                        <mat-option *ngFor="let option of this.questionsSelectMap[index] | keyvalue; index as i2" [value]="i2 + 1" (onSelectionChange)="questionSelectChange($event, index, question)">{{i2 + 1}}</mat-option>
                      </mat-select>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumnsQuestions"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsQuestions;"></tr>
                </table>
              </div>
            </div>

            <div class="wizard-buttons-container align-right">
              <button mat-raised-button matStepperPrevious (click)="resetQuestions()">
                <mat-icon class="material-icons-outlined">chevron_left</mat-icon>
                <span>Back</span>
              </button>
              <button mat-raised-button matStepperNext type="button" color="primary"
                      (click)="summaryStep()" [disabled]="!allQuestionsSelectedWithOrder">
                <span>Next</span>
                <mat-icon class="material-icons-outlined">chevron_right</mat-icon>
              </button>
            </div>
          </mat-step>

          <mat-step >
            <ng-template matStepLabel>Summary</ng-template>
            <ng-template matStepContent>
              <div class="table-container" *ngFor="let questionsPerCategory of questionsSelectMap; index as index">
                <div *ngIf="questionsPerCategory.size > 0">
                  <h3>{{questions[index]?.length > 0 ? questions[index][0].category.description : ''}}</h3>
                  <table class="questions-table" #summaryTable mat-table [dataSource]="questionsPerCategory | keyvalue: valueOrderAsc">

                    <ng-container matColumnDef="questions.shortCode">
                      <th mat-header-cell *matHeaderCellDef>{{"intelligence-reporting.questions.short-code" |translate}}</th>
                      <td mat-cell *matCellDef="let question">{{question.key.shortCode}}</td>
                    </ng-container>

                    <ng-container matColumnDef="questions.description">
                      <th mat-header-cell *matHeaderCellDef>{{"admin.dialogs.description" |translate}}</th>
                      <td mat-cell *matCellDef="let question">{{question.key.description }}</td>
                    </ng-container>

                    <ng-container matColumnDef="questions.questionType">
                      <th mat-header-cell *matHeaderCellDef>{{"intelligence-reporting.questions.registration-level" |translate}}</th>
                      <td mat-cell *matCellDef="let question">{{question.key.questionType}}</td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumnsSummary"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsSummary;"></tr>
                  </table>
                </div>
              </div>

              <div class="edit-dialog-buttons-container">
                <button mat-raised-button matStepperPrevious [disabled]="data.launched !== null">
                  <mat-icon class="material-icons-outlined" (click)="summary = false">chevron_left</mat-icon>
                  <span>Back</span>
                </button>
                <button mat-raised-button (click)="closeDialog()" type="button" >
                  <span>Close</span>
                </button>
                <button [disabled]="roundOfQuestionsCreateForm.invalid" mat-raised-button color="primary" type="submit">
                  <span>Save</span>
                </button>
                <button *ngIf="data.launched === null" [disabled]="roundOfQuestionsCreateForm.invalid"
                        mat-raised-button color="primary" type="button"
                        (click)="launch()">
                  <span>Launch</span>
                </button>
              </div>
            </ng-template>
          </mat-step>

        </mat-stepper>
      </div>
    </form>
  </mat-card-content>
</mat-dialog-content>
